import { Fragment } from 'react';
import { ShopsDropdown } from '~/components';
import { RemoteAppointmentInformation } from '../components';
import { PATH_NAMES } from '../constants';

export const config = {
  v2: {
    appointment: {
      name: 'Nursery Advice',
    },
    ReviewForm: {
      shopDetails: {
        title: 'Service provided by',
      },
    },
    AboutYou: {
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
              <p>
                {'We will call you on this number at the time of your appointment.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
    additionalShopTitle: 'Our Partners host virtual appointments by video or phone call. You can book at any shop or select one nearer to you.',
    searchResultTitle: 'Shops offering virtual appointments near',
    searchResultDescription: 'If you can\'t find a slot at a shop nearby, you can book at any other shop.',
    shopAddress: 'Virtual Service',
    selectDateTitle: 'Select a date for your virtual appointment',
    subtitleComponent: ({ className, secondLineClassName }) => (
      <div className={className}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
        <p className={secondLineClassName}>If you can&apos;t find a preferred slot at your selected shop please try another one.</p>
      </div>
    ),
    ShopsDropdown,
    selectDatePrevPath: PATH_NAMES.SELECT_SHOP,
    editDatePrevPath: PATH_NAMES.EDIT_SHOP,
    hideFilters: true,
  },
};
